import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

export default (locale = 'ru') => {
  return new VueI18n({
    locale,
    fallbackLocale: 'ru',
  });
};
